import React from 'react';
import { FormComponent } from '../../../components/form/DynamicForm'
import { Form, Validators } from '../../../components/form/DynamicFormTs'
import Http from '../../../Http';
import { withRouter } from "react-router-dom";
import { objectAsParams } from '../../../helpers';

class Usuario extends FormComponent {

  componentDidMount() {
    this.initialData = true;
    this.FormConfig(
      { defaultUrl: 'usuario/one', saveUrl: 'usuario/signup', backUrl: '/ConfiguracionSistema/Usuarios' },
      new Form([
        Form.Field('text', 'nombre', 'Nombre ', '', [Validators.required], 6),
        Form.Field('text', 'apellido_paterno', 'Apellido Paterno ', '', [Validators.required], 6),
        Form.Field('text', 'apellido_materno', 'Apellido Materno ', '', [Validators.required], 6),
        Form.Field('text', 'email', 'Correo Electronico ', '', [Validators.required, Validators.email], 6),
        Form.Field('password', 'password', 'Contraseña ', '', [Validators.required], 6),
        Form.Field('password', 'confirm_password', 'Confirmar Contraseña ', '', [Validators.required], 6),
        Form.Field('select', 'id_sucursal', 'Sucursal ', '', [Validators.required], 6),
        Form.Field('select', 'id_rol', 'Rol ', '', [Validators.required], 6),
        Form.Field('autocomplete', 'id_cliente', 'Cliente', '', [Validators.required], 12),
        Form.Field('checkbox', 'todas_sucursales', 'Permitir crear guías de diferentes sucursales', 0, [], 6),
        Form.Field('checkbox', 'login_web', 'Permitir entrar a la pagina', 0, [], 6),
        Form.Field('checkbox', 'login_api', 'Permitir usar el web service', 0, [], 6),
        Form.Field('select', 'situacion_estado', 'Situación ', '', [], 12, [
          { Value: 1, Label: "Activo" },
          { Value: 10, Label: "Bloqueado" },
        ]),
      ], ['Guardar'], 'Agregar Usuario'), this.formData
    )
    if (this.props.id_user)
      this.loadPressForm(this.props.id_user);
  }

  componentDidUpdate(prevProps) {
    if (this.props.id_user !== prevProps.id_user) {
      this.loadPressForm(this.props.id_user);
    }
  }

  formData = async (form) => {
    let newForm = form;
    const params = {};
    if (this.formCliClve) {
      params["cli_rs"] = this.formCliClve;
      this.formCliClve = null;
    }
    if (this.initialData) {
      params["initial_data"] = true;
    }
    if (this.clienteId) {
      params["cli_id"] = this.clienteId;
    }
    const Res = await Http.get(`usuario/form?${objectAsParams(params)}`);
    if (!Res.error) {
      const { clientes, roles, sucursales } = Res.data;
      if (clientes) {
        newForm = Form.FieldOptions(newForm, 'id_cliente', clientes, 'id', 'cliente_rsocial');
      }
      if (roles) {
        newForm = Form.FieldOptions(form, 'id_rol', roles, 'id', 'rol_nombre');
      }
      if (sucursales) {
        newForm = Form.FieldOptions(form, 'id_sucursal', sucursales, 'id', 'sucursal_nombre');
      }
    }

    newForm = Form.ValueChange(newForm, {
      password: this.passwordChange,
      confirm_password: this.passwordChange,
      id_cliente: async (field) => { this.clienteChange(field, 'formCliClve') },
    });
    return newForm;
  }

  passwordChange = async (field) => {
    const password = this.state.FormData.Fields.find(field => field.Name === 'password');
    const confirmPassword = this.state.FormData.Fields.find(field => field.Name === 'confirm_password');
    const errors = [];

    if ((password.Value.length > 0) && (confirmPassword.Value.length > 0) && password.Value !== confirmPassword.Value) {
      errors.push('Las contraseñas no coinciden');
    }

    this.setState({ FormData: Form.SetInvalidField(this.state.FormData, 'password', errors) }, () => {
      this.setState({ FormData: Form.SetInvalidField(this.state.FormData, 'confirm_password', errors) });
    })
  }

  clienteChange = async (field, variable) => {
    if (field.Value && !isNaN(field.Value)) {
      let Res = await Http.get(`cliente/one/${field.Value}`);
      if (!Res.error) {
        const { id } = Res.data;
        this.formCliId = Res.data.id;
        this.setState({ id_cliente: id });
      }
    } else {
      this[variable] = field.ValueAt;
      this.setState({
        FormData: await this.formData(this.state.FormData)
      });
    }
  }

  onSubmit = async (i, vals) => {
    this.setState({ loading: true });
    if (this.props.id_user) {
      vals.id = this.props.id_user;
      this.config.saveUrl = 'usuario/edit';
    }
    var Res = await Http.post(`${this.config.saveUrl}`, vals);

    if (!Res.error) {
      this.setState({ loading: false, sbMsg: 'Guardado', sbOpen: true });
      if (this.props.reset)
        this.setState({ FormData: Form.Reset(this.state.FormData) });

      if (this.props.back)
        this.props.history.push(`${this.config.backUrl}`)
      this.props.onSave();
    }
    else
      this.setState({ loading: false, sbMsg: `Error al guardar${(Res.errMsg ? `: ${Res.errMsg}` : '')}`, sbOpen: true });

  }

  loadPressForm = async (id) => {
    const data = await this.LoadPreds(id);
    let newForm = Form.FieldMod(this.state.FormData, 'password', 'Type', 'hidden');
    newForm = Form.FieldMod(newForm, 'confirm_password', 'Type', 'hidden');
    newForm = Form.FieldMod(newForm, 'password', 'Validators', []);
    newForm = Form.FieldMod(newForm, 'confirm_password', 'Validators', []);
    this.clienteId = data.id_cliente;
    newForm = await this.formData(newForm);
    this.initialData = false;
    this.setState({ FormData: newForm })
  }

  render() {
    return (
      <div>
        <this.FormRender {...this.props} />
      </div>
    )
  }
}


export default withRouter(Usuario)
